<template>
  <WithTopNav :leftText="$t('meu.CPFInterface.Title')" class="cpf text-13">
    <div class="text-15 py-2 px-4">
      <div class="cellGroup">
        <van-cell-group inset :title="$t('meu.CPFInterface.PersonalInfo')">
          <van-cell :title="$t('meu.CPFInterface.Name')" :value="cpfInfo.accountName || '--' " />
          <van-cell :title="$t('meu.CPFInterface.CPF')" :value="cpfInfo.cpf || '--' " />
        </van-cell-group>
      </div>

      <div class="cellGroup">
        <van-cell-group inset :title="$t('meu.CPFInterface.PixAccount')">
          <van-cell :title="$t('meu.CPFInterface.CPFId')" :value="cpfInfo.cpfId || '--' " />
          <van-cell :title="$t('meu.CPFInterface.Mobile')" :value="cpfInfo.accountMobile || '--' " />
          <van-cell :title="$t('meu.CPFInterface.Email')" :value="cpfInfo.accountEmail || '--' " />
          <van-cell :title="$t('meu.CPFInterface.CNPJ')" :value="cpfInfo.accountCnpj || '--' " />
        </van-cell-group>
      </div>
    </div>
  </WithTopNav>
</template>

<script setup lang="ts">
  import WithTopNav from '@/layouts/withTopNav.vue'
  import { getSaqueInfo } from '@/api/saque'
  
  const cpfInfo = ref({
    count: false,
    userid: 0,
    accountName: "",
    cpf: "",
    cpfId: "",
    accountEmail: "",
    accountMobile: "",
    accountCnpj: "",
    accountEvp: "",
    weight: 0,
    status: "",
    payeeName: "",
    payeeCpf: "",
    username: "",
    balance: 0,
    limitAmount: 0,
    limit: 0,
    skip: 0
  })

  onMounted(async () => {
    const { code, data } = await getSaqueInfo()
    if (code === 1 && data) {
      cpfInfo.value = data
    }
  })
</script>

<style lang="scss">
.cellGroup{
  .van-cell-group__title--inset{
    padding: 12px 0;
    color: white;
    display: flex;
    font-size: 15px;


    &:before{
      content: '';
      display: block;
      width: 3px;
      height: 15px;
      background-color: white;
      border-radius: 4px;
      margin-right: 8px;
    }
  }

  .van-icon-arrow:before{
    color: white;
  }

  .van-cell-group{
    background-color: transparent !important;
  }

  .van-cell-group--inset{
    margin: 0 0 0;
  }

  .van-cell{
    color: white;
    font-size: 15px;

    &:nth-child(odd){
      background-color: var(--theme-gray-green40);
    }

    &:nth-child(even){
      background-color: var(--theme-gray-green20);
    }

    &:after{
      border-bottom: 3px solid #151A1F;
      left: 0; right: 0;
      bottom: -1px
    }
  }

  .van-cell__value{
    color: rgba(255, 255, 255, 0.75);
  }
}

</style>
